module.exports = __webpack_public_path__ + "media/audios/kid/lesson_3/audio13-22ff6f4b39f31b3dc2692cd775d86844.m4a";